export default "__VITE_ASSET__1bfa2384__"